<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Delivery Man {{ (inputName) ? (" - " + this.delivery_man.first_name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Delivery Man - {{this.delivery_man.first_name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Delivery Man - {{this.delivery_man.first_name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{delivery_man.created_by || "System" }} | {{delivery_man.created_at | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{delivery_man.updated_by || "System" }} | {{delivery_man.updated_at | dateFilter}} 
            </b-tab>
        </b-tabs>

        <form id="form-proper">

            <!-- {{delivery_man}} -->
            <div v-if="customFormMode == 1" v-show="showDetails">
                 <!-- Normal -->
                <base-input alternative="" label="Code" placeholder="" v-model="delivery_man.code" input-classes="form-control"/>
                <base-input alternative="" label="Name" placeholder="" v-model="delivery_man.name" input-classes="form-control" required />
                <!-- <base-input alternative="" label="Last Name" placeholder="" v-model="delivery_man.last_name" input-classes="form-control" required /> -->
                <base-input alternative="" label="Supplier">
                    <a-select style="width: 100%" placeholder="Enter supplier name from list" v-model="delivery_man.supplier_id">
                        <a-select-option v-for="supplier in supplierList" :key="supplier.id" :value="supplier.id">{{supplier.name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="delivery_man" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="delivery_man.code" input-classes="form-control"/>
                        <base-input alternative="" label="Name" placeholder="" v-model="delivery_man.name" input-classes="form-control" required />
                        <!-- <base-input alternative="" label="First Name" placeholder="" v-model="delivery_man.first_name" input-classes="form-control" required />
                        <base-input alternative="" label="Last Name" placeholder="" v-model="delivery_man.last_name" input-classes="form-control" required /> -->
                        <base-input alternative="" label="Supplier">
                            <a-select style="width: 100%" placeholder="Enter supplier name from list" v-model="delivery_man.supplier_id">
                                <a-select-option v-for="supplier in supplierList" :key="supplier.id" :value="supplier.id">{{supplier.name}}</a-select-option>
                            </a-select>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="delivery_man" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>


            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-delivery_man: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-delivery_man: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    import moment from 'moment'
    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            this.loading = true
            this.supplierList = this.$attrs.supplierList

            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Delivery Man?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            
        
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }

            // const suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?mode=all' , null)
            // this.supplierList = suppliers

            component_x = this
            if (component_x.profileId > 0){
                var delivery_man_data = await HTTPRequest.getRequest(component_x.endPoint + 'delivery_men/' + component_x.profileId, null)
                if(delivery_man_data == undefined){
                    component_x.$router.go()
                } else {
                    if(delivery_man_data["error"] == undefined){
                        component_x.delivery_man = delivery_man_data
                    } else {
                        this.errors = delivery_man_data["error"].split(",");
                    } 
                }
            } 

            this.loading = false
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                errors: [],
                loading: false,
                showDetails: true,

                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                delivery_man: {},
                formErrors: [],
                supplierList: []
            }
        },
        filters: {
            dateFilter: function (timestamp) {
                return moment(timestamp).format('L LTS')
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            openDetails() {
                this.showDetails = true
            },
            openHistory() {
                this.showDetails = false
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                this.errors.push(ValidateField.alphanumericWithSeparator('Code', this.delivery_man.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.delivery_man.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.delivery_man.name));
                // this.errors.push(ValidateField.alphanumericWithSpace(' Name', this.delivery_man.first_name));
                // this.errors.push(ValidateField.required('Last Name', this.delivery_man.last_name));
                // this.errors.push(ValidateField.alphanumericWithSpace('Last Name', this.delivery_man.last_name));
                // this.errors.push(ValidateField.charMinAndMax('Name', this.delivery_man.name, 0, 50));
                this.errors.push(ValidateField.required('Supplier', this.delivery_man.supplier_id));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var delivery_manPayload = {
                    //     delivery_man: {
                    //         name: this.inputName.trim(), 
                    //         code: this.inputCode.trim(), 
                    //         remark: this.inputRemark, 
                    //         status: 'A'
                    //     }
                    // }

                    this.delivery_man.first_name = this.delivery_man.first_name
                    this.delivery_man.last_name = this.delivery_man.last_name
                    if (this.delivery_man.code != undefined)
                        this.delivery_man.code = this.delivery_man.code
                    this.delivery_man.status = 'A'
                    var delivery_manPayload = { delivery_man: this.delivery_man }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'delivery_men', null, delivery_manPayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {

                    this.delivery_man.name = this.delivery_man.name.trim()
                    if (this.delivery_man.code != undefined)
                        this.delivery_man.code = this.delivery_man.code.trim()
                    let status = (this.delivery_man.status == null) ?  "A" : this.delivery_man.status
                    this.delivery_man.status = status
                    // this.delivery_man.status = 'A'
                    var delivery_manPayload = { delivery_man: this.delivery_man }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'delivery_men/' + this.profileId, null, delivery_manPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>